<template>
  <div>
    <template v-if="type==='math'">
      <header class="header">
        <img
          class="head-img"
          src="https://static-app-manager.zmlearn.com/o5Aq2Smh3485.png"
          alt=""
        />
        <img
          class="receive"
          src="https://static-app-manager.zmlearn.com/WRE4Z84j7270.png"
          @click="showForm('1', 'click_kid_act24_ljlq')"
          alt=""
        />
      </header>

      <img
        class="main main-1"
        src="https://static-app-manager.zmlearn.com/NWVtO3v-7375.png"
        alt=""
      />
      <img
        class="main"
        src="https://static-app-manager.zmlearn.com/8uPjlohU1069.png"
        alt=""
      />
      <div class="system-wrap">
        <div class="tab-wrap">
          <a
            href="javascript:;"
            @click="changeBanner(item - 1)"
            v-for="item in 5"
            :key="item"
          ></a>
        </div>
        <img
          class="sysyem-item"
          v-show="curBanner === index"
          v-for="(item, index) in bannerUrl"
          :key="item"
          :src="item"
          alt=""
        />
        <img
          class="main"
          src="https://static-app-manager.zmlearn.com/emLu4wLC3065.png"
          alt=""
        />
      </div>
      <img
        class="main"
        src="https://static-app-manager.zmlearn.com/HNnM_olw2895.png"
        alt=""
      />
      <img
        class="main"
        src="https://static-app-manager.zmlearn.com/rQ7LWGcG7891.png"
        alt=""
      />
      <a class="footer" @click="showForm('2', 'click_kid_act24_ljlq')" href="javscript:;">
        <img src="https://static-app-manager.zmlearn.com/aWO2kR382554.png" alt="">
      </a>
    </template>
    <template v-else>
      <header class="header">
        <img
          class="head-img"
          src="https://static-app-manager.zmlearn.com/0PYhh8AQ6517.png"
          alt=""
        />
        <img
          class="receive"
          src="https://static-app-manager.zmlearn.com/E_AUqQZ31638.png"
          @click="showForm('1', 'click_kid_act25_ljlq')"
          alt=""
        />
      </header>

      <img
        class="main main-1"
        src="https://static-app-manager.zmlearn.com/ccYRSikk9985.png"
        alt=""
      />
      <img
        class="main"
        src="https://static-app-manager.zmlearn.com/vXMmeqSv6244.png"
        alt=""
      />
      <img
        class="main"
        src="https://static-app-manager.zmlearn.com/dBSoD49B3396.png"
        alt=""
      />
      <img
        class="main"
        src="https://static-app-manager.zmlearn.com/4b6oqmkc2803.png"
        alt=""
      />
      <img
        class="main"
        src="https://static-app-manager.zmlearn.com/rQ7LWGcG7891.png"
        alt=""
      />
      <a class="footer" @click="showForm('2', 'click_kid_act25_ljlq')" href="javscript:;">
        <img src="https://static-app-manager.zmlearn.com/bu5RcTNL6278.png" alt="">
      </a>
    </template>

    <div class="dialog-form" v-show="showDialogForm">
      <div class="lesson-form-content">
        <div class="lesson-form-box">
          <lesson-form :type="type"></lesson-form>
          <img
            alt="close"
            class="dialog-form-close"
            src="https://web-data.zmlearn.com/image/pMeJFjz6QKFohpr9b4wPSH/icon_close.png"
            @click="showDialogForm = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import lessonForm from "./lesson-form";

export default {
  components: {
    lessonForm,
  },
  props: {
    type: String,
    // eslint-disable-next-line vue/require-prop-type-constructor
    default: 'math'
  },
  data() {
    return {
      curBanner: 0,
      showDialogForm: false,
      bannerUrl: [
        "https://static-app-manager.zmlearn.com/z2k23vjU1732.png",
        "https://static-app-manager.zmlearn.com/uTlYylfJ5458.png",
        "https://static-app-manager.zmlearn.com/E5BvNjXS4955.png",
        "https://static-app-manager.zmlearn.com/tS7dOvhN4979.png",
        "https://static-app-manager.zmlearn.com/_zWqbfLj5796.png",
      ],
    };
  },
  methods: {
    changeBanner(index) {
      this.curBanner = index;
    },
    showForm(position, eventId) {
      this.showDialogForm = true;
      ZM_JSSDK &&
      ZM_JSSDK.sendEvent({
        eventId,
        eventParam: {
          position
        }
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.header {
  position: relative;
}

.head-img {
  width: 100%;
}

.receive {
  position: absolute;
  top: px2rem(969);
  left: 50%;
  width: px2rem(634);
  height: px2rem(138);
  transform: translateX(-50%);
}

.system-wrap {
  position: relative;

  .sysyem-item {
    position: absolute;
    top: px2rem(240);
    left: 50%;
    width: px2rem(671);
    height: px2rem(621);
    transform: translateX(-50%);
  }

  .tab-wrap {
    display: flex;
    position: absolute;
    top: px2rem(240);
    left: 50%;
    z-index: 1;
    width: px2rem(671);
    height: px2rem(75);
    transform: translateX(-50%);
    font-size: 0;

    a {
      width: px2rem(120);
      height: 100%;

      + a {
        margin-left: px2rem(20);
      }
    }
  }
}

.main {
  margin-top: px2rem(60);
  width: 100%;
}

.main-1 {
  margin-top: px2rem(23);
}

.dialog-form {
  position: fixed;
  z-index: 2;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.lesson-form-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;

  .dialog-form-close {
    margin-top: px2rem(20);
    width: px2rem(75);
    height: px2rem(75);
  }
}

.footer {
  position: fixed;
  bottom: px2rem(-6);
  left: 0;
  width: 100%;

  img {
    width: 100%;
  }
}
</style>